
import kebabCase from 'lodash.kebabcase';
import type { ClickOrPressEvent } from 'types/mouseEvents';

// *****To update this file see `tools/generate-icon-imports.mjs`*****

import { ReactComponent as AccountCircle } from 'assets/icons/account-circle.svg?react';
import { ReactComponent as Add } from 'assets/icons/add.svg?react';
import { ReactComponent as Apartment } from 'assets/icons/apartment.svg?react';
import { ReactComponent as AppRegistration } from 'assets/icons/app-registration.svg?react';
import { ReactComponent as Apps } from 'assets/icons/apps.svg?react';
import { ReactComponent as ArrowAngled } from 'assets/icons/arrow-angled.svg?react';
import { ReactComponent as ArrowDown } from 'assets/icons/arrow-down.svg?react';
import { ReactComponent as ArrowDropDown } from 'assets/icons/arrow-drop-down.svg?react';
import { ReactComponent as ArrowDropUp } from 'assets/icons/arrow-drop-up.svg?react';
import { ReactComponent as ArrowLeftAlt } from 'assets/icons/arrow-left-alt.svg?react';
import { ReactComponent as ArrowLeft } from 'assets/icons/arrow-left.svg?react';
import { ReactComponent as ArrowRightAlt } from 'assets/icons/arrow-right-alt.svg?react';
import { ReactComponent as ArrowRight } from 'assets/icons/arrow-right.svg?react';
import { ReactComponent as ArrowUp } from 'assets/icons/arrow-up.svg?react';
import { ReactComponent as Assignment } from 'assets/icons/assignment.svg?react';
import { ReactComponent as Autorenew } from 'assets/icons/autorenew.svg?react';
import { ReactComponent as BarChart4Bars } from 'assets/icons/bar-chart-4-bars.svg?react';
import { ReactComponent as BarChart } from 'assets/icons/bar-chart.svg?react';
import { ReactComponent as Brochure } from 'assets/icons/brochure.svg?react';
import { ReactComponent as BulletOutline } from 'assets/icons/bullet-outline.svg?react';
import { ReactComponent as BulletSolid } from 'assets/icons/bullet-solid.svg?react';
import { ReactComponent as Calculate } from 'assets/icons/calculate.svg?react';
import { ReactComponent as Calculator } from 'assets/icons/calculator.svg?react';
import { ReactComponent as CalendarMonth } from 'assets/icons/calendar-month.svg?react';
import { ReactComponent as Calendar } from 'assets/icons/calendar.svg?react';
import { ReactComponent as CallCenter } from 'assets/icons/call-center.svg?react';
import { ReactComponent as Call } from 'assets/icons/call.svg?react';
import { ReactComponent as CancelFill } from 'assets/icons/cancel-fill.svg?react';
import { ReactComponent as Careers } from 'assets/icons/careers.svg?react';
import { ReactComponent as CheckBox } from 'assets/icons/check-box.svg?react';
import { ReactComponent as CheckCircleOutline } from 'assets/icons/check-circle-outline.svg?react';
import { ReactComponent as CheckCircle } from 'assets/icons/check-circle.svg?react';
import { ReactComponent as Check } from 'assets/icons/check.svg?react';
import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down.svg?react';
import { ReactComponent as ChevronLeft } from 'assets/icons/chevron-left.svg?react';
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg?react';
import { ReactComponent as ChevronUp } from 'assets/icons/chevron-up.svg?react';
import { ReactComponent as Close } from 'assets/icons/close.svg?react';
import { ReactComponent as CloudUploadFill } from 'assets/icons/cloud-upload-fill.svg?react';
import { ReactComponent as Counter1 } from 'assets/icons/counter-1.svg?react';
import { ReactComponent as Counter2 } from 'assets/icons/counter-2.svg?react';
import { ReactComponent as Counter3 } from 'assets/icons/counter-3.svg?react';
import { ReactComponent as Counter4 } from 'assets/icons/counter-4.svg?react';
import { ReactComponent as CreditCard } from 'assets/icons/credit-card.svg?react';
import { ReactComponent as CrossCircle } from 'assets/icons/cross-circle.svg?react';
import { ReactComponent as DateRange } from 'assets/icons/date-range.svg?react';
import { ReactComponent as Delete } from 'assets/icons/delete.svg?react';
import { ReactComponent as Description } from 'assets/icons/description.svg?react';
import { ReactComponent as Disclaimer } from 'assets/icons/disclaimer.svg?react';
import { ReactComponent as Diversity1 } from 'assets/icons/diversity-1.svg?react';
import { ReactComponent as Diversity3 } from 'assets/icons/diversity-3.svg?react';
import { ReactComponent as Docs } from 'assets/icons/docs.svg?react';
import { ReactComponent as Dollar } from 'assets/icons/dollar.svg?react';
import { ReactComponent as DownloadBox } from 'assets/icons/download-box.svg?react';
import { ReactComponent as Download } from 'assets/icons/download.svg?react';
import { ReactComponent as Eco } from 'assets/icons/eco.svg?react';
import { ReactComponent as EditFill } from 'assets/icons/edit-fill.svg?react';
import { ReactComponent as Email } from 'assets/icons/email.svg?react';
import { ReactComponent as Emergency } from 'assets/icons/emergency.svg?react';
import { ReactComponent as ErrorOutline } from 'assets/icons/error-outline.svg?react';
import { ReactComponent as Error } from 'assets/icons/error.svg?react';
import { ReactComponent as EventRepeat } from 'assets/icons/event-repeat.svg?react';
import { ReactComponent as EventUpcoming } from 'assets/icons/event-upcoming.svg?react';
import { ReactComponent as Exclamation } from 'assets/icons/exclamation.svg?react';
import { ReactComponent as ExternalLink } from 'assets/icons/external-link.svg?react';
import { ReactComponent as Facebook } from 'assets/icons/facebook.svg?react';
import { ReactComponent as Faq } from 'assets/icons/faq.svg?react';
import { ReactComponent as Fax } from 'assets/icons/fax.svg?react';
import { ReactComponent as FileCopy } from 'assets/icons/file-copy.svg?react';
import { ReactComponent as FinanceMode } from 'assets/icons/finance-mode.svg?react';
import { ReactComponent as Forum } from 'assets/icons/forum.svg?react';
import { ReactComponent as Google } from 'assets/icons/google.svg?react';
import { ReactComponent as Groups } from 'assets/icons/groups.svg?react';
import { ReactComponent as HeadsetMic } from 'assets/icons/headset-mic.svg?react';
import { ReactComponent as Help } from 'assets/icons/help.svg?react';
import { ReactComponent as Home } from 'assets/icons/home.svg?react';
import { ReactComponent as ImageFill } from 'assets/icons/image-fill.svg?react';
import { ReactComponent as Info } from 'assets/icons/info.svg?react';
import { ReactComponent as Information } from 'assets/icons/information.svg?react';
import { ReactComponent as Instagram } from 'assets/icons/instagram.svg?react';
import { ReactComponent as KeyboardArrowDown } from 'assets/icons/keyboard-arrow-down.svg?react';
import { ReactComponent as Language } from 'assets/icons/language.svg?react';
import { ReactComponent as LgChevronLeft } from 'assets/icons/lg-chevron-left.svg?react';
import { ReactComponent as LgChevronRight } from 'assets/icons/lg-chevron-right.svg?react';
import { ReactComponent as Link } from 'assets/icons/link.svg?react';
import { ReactComponent as Linkedin } from 'assets/icons/linkedin.svg?react';
import { ReactComponent as ListAltCheck } from 'assets/icons/list-alt-check.svg?react';
import { ReactComponent as List } from 'assets/icons/list.svg?react';
import { ReactComponent as LocationOn } from 'assets/icons/location-on.svg?react';
import { ReactComponent as LockFilled } from 'assets/icons/lock-filled.svg?react';
import { ReactComponent as Login } from 'assets/icons/login.svg?react';
import { ReactComponent as Mail } from 'assets/icons/mail.svg?react';
import { ReactComponent as MapsFill } from 'assets/icons/maps-fill.svg?react';
import { ReactComponent as Menu } from 'assets/icons/menu.svg?react';
import { ReactComponent as Messenger } from 'assets/icons/messenger.svg?react';
import { ReactComponent as MoneyBag } from 'assets/icons/money-bag.svg?react';
import { ReactComponent as Monitoring } from 'assets/icons/monitoring.svg?react';
import { ReactComponent as MoreHoriz } from 'assets/icons/more-horiz.svg?react';
import { ReactComponent as MoreVert } from 'assets/icons/more-vert.svg?react';
import { ReactComponent as Moving } from 'assets/icons/moving.svg?react';
import { ReactComponent as NestClockFarsightAnalog } from 'assets/icons/nest-clock-farsight-analog.svg?react';
import { ReactComponent as News2 } from 'assets/icons/news-2.svg?react';
import { ReactComponent as News } from 'assets/icons/news.svg?react';
import { ReactComponent as Office } from 'assets/icons/office.svg?react';
import { ReactComponent as OpenInNew } from 'assets/icons/open-in-new.svg?react';
import { ReactComponent as PageInfo } from 'assets/icons/page-info.svg?react';
import { ReactComponent as Paid } from 'assets/icons/paid.svg?react';
import { ReactComponent as Pdf } from 'assets/icons/pdf.svg?react';
import { ReactComponent as PersonAdd } from 'assets/icons/person-add.svg?react';
import { ReactComponent as PersonOutline } from 'assets/icons/person-outline.svg?react';
import { ReactComponent as Person } from 'assets/icons/person.svg?react';
import { ReactComponent as PictureAsPdf } from 'assets/icons/picture-as-pdf.svg?react';
import { ReactComponent as Pinterest } from 'assets/icons/pinterest.svg?react';
import { ReactComponent as PlayArrow } from 'assets/icons/play-arrow.svg?react';
import { ReactComponent as PlayCircle } from 'assets/icons/play-circle.svg?react';
import { ReactComponent as Protection } from 'assets/icons/protection.svg?react';
import { ReactComponent as QuickReference } from 'assets/icons/quick-reference.svg?react';
import { ReactComponent as Remove } from 'assets/icons/remove.svg?react';
import { ReactComponent as RestartAlt } from 'assets/icons/restart-alt.svg?react';
import { ReactComponent as Savings } from 'assets/icons/savings.svg?react';
import { ReactComponent as School } from 'assets/icons/school.svg?react';
import { ReactComponent as Search } from 'assets/icons/search.svg?react';
import { ReactComponent as Secure } from 'assets/icons/secure.svg?react';
import { ReactComponent as Security } from 'assets/icons/security.svg?react';
import { ReactComponent as Seminars } from 'assets/icons/seminars.svg?react';
import { ReactComponent as Settings } from 'assets/icons/settings.svg?react';
import { ReactComponent as Share } from 'assets/icons/share.svg?react';
import { ReactComponent as ShieldPerson } from 'assets/icons/shield-person.svg?react';
import { ReactComponent as SourceEnvironment } from 'assets/icons/source-environment.svg?react';
import { ReactComponent as SquareCheck } from 'assets/icons/square-check.svg?react';
import { ReactComponent as Star } from 'assets/icons/star.svg?react';
import { ReactComponent as SupervisedUserCircle } from 'assets/icons/supervised-user-circle.svg?react';
import { ReactComponent as SwitchAccount } from 'assets/icons/switch-account.svg?react';
import { ReactComponent as Task } from 'assets/icons/task.svg?react';
import { ReactComponent as TextSnippet } from 'assets/icons/text-snippet.svg?react';
import { ReactComponent as Time } from 'assets/icons/time.svg?react';
import { ReactComponent as Translate } from 'assets/icons/translate.svg?react';
import { ReactComponent as UploadBox } from 'assets/icons/upload-box.svg?react';
import { ReactComponent as VerifiedUser } from 'assets/icons/verified-user.svg?react';
import { ReactComponent as VisibilityOff } from 'assets/icons/visibility-off.svg?react';
import { ReactComponent as Visibility } from 'assets/icons/visibility.svg?react';
import { ReactComponent as Visit } from 'assets/icons/visit.svg?react';
import { ReactComponent as Warning } from 'assets/icons/warning.svg?react';
import { ReactComponent as Whatsapp } from 'assets/icons/whatsapp.svg?react';
import { ReactComponent as X } from 'assets/icons/x.svg?react';
import { ReactComponent as Youtube } from 'assets/icons/youtube.svg?react';

export type IconString =

| 'account-circle'
| 'add'
| 'apartment'
| 'app-registration'
| 'apps'
| 'arrow-angled'
| 'arrow-down'
| 'arrow-drop-down'
| 'arrow-drop-up'
| 'arrow-left-alt'
| 'arrow-left'
| 'arrow-right-alt'
| 'arrow-right'
| 'arrow-up'
| 'assignment'
| 'autorenew'
| 'bar-chart-4-bars'
| 'bar-chart'
| 'brochure'
| 'bullet-outline'
| 'bullet-solid'
| 'calculate'
| 'calculator'
| 'calendar-month'
| 'calendar'
| 'call-center'
| 'call'
| 'cancel-fill'
| 'careers'
| 'check-box'
| 'check-circle-outline'
| 'check-circle'
| 'check'
| 'chevron-down'
| 'chevron-left'
| 'chevron-right'
| 'chevron-up'
| 'close'
| 'cloud-upload-fill'
| 'counter-1'
| 'counter-2'
| 'counter-3'
| 'counter-4'
| 'credit-card'
| 'cross-circle'
| 'date-range'
| 'delete'
| 'description'
| 'disclaimer'
| 'diversity-1'
| 'diversity-3'
| 'docs'
| 'dollar'
| 'download-box'
| 'download'
| 'eco'
| 'edit-fill'
| 'email'
| 'emergency'
| 'error-outline'
| 'error'
| 'event-repeat'
| 'event-upcoming'
| 'exclamation'
| 'external-link'
| 'facebook'
| 'faq'
| 'fax'
| 'file-copy'
| 'finance-mode'
| 'forum'
| 'google'
| 'groups'
| 'headset-mic'
| 'help'
| 'home'
| 'image-fill'
| 'info'
| 'information'
| 'instagram'
| 'keyboard-arrow-down'
| 'language'
| 'lg-chevron-left'
| 'lg-chevron-right'
| 'link'
| 'linkedin'
| 'list-alt-check'
| 'list'
| 'location-on'
| 'lock-filled'
| 'login'
| 'mail'
| 'maps-fill'
| 'menu'
| 'messenger'
| 'money-bag'
| 'monitoring'
| 'more-horiz'
| 'more-vert'
| 'moving'
| 'nest-clock-farsight-analog'
| 'news-2'
| 'news'
| 'office'
| 'open-in-new'
| 'page-info'
| 'paid'
| 'pdf'
| 'person-add'
| 'person-outline'
| 'person'
| 'picture-as-pdf'
| 'pinterest'
| 'play-arrow'
| 'play-circle'
| 'protection'
| 'quick-reference'
| 'remove'
| 'restart-alt'
| 'savings'
| 'school'
| 'search'
| 'secure'
| 'security'
| 'seminars'
| 'settings'
| 'share'
| 'shield-person'
| 'source-environment'
| 'square-check'
| 'star'
| 'supervised-user-circle'
| 'switch-account'
| 'task'
| 'text-snippet'
| 'time'
| 'translate'
| 'upload-box'
| 'verified-user'
| 'visibility-off'
| 'visibility'
| 'visit'
| 'warning'
| 'whatsapp'
| 'x'
| 'youtube';

export type IconSVG = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
export const allIconComponents: Record<IconString, IconSVG> = {
    'account-circle': AccountCircle,
    add: Add,
    apartment: Apartment,
    'app-registration': AppRegistration,
    apps: Apps,
    'arrow-angled': ArrowAngled,
    'arrow-down': ArrowDown,
    'arrow-drop-down': ArrowDropDown,
    'arrow-drop-up': ArrowDropUp,
    'arrow-left-alt': ArrowLeftAlt,
    'arrow-left': ArrowLeft,
    'arrow-right-alt': ArrowRightAlt,
    'arrow-right': ArrowRight,
    'arrow-up': ArrowUp,
    assignment: Assignment,
    autorenew: Autorenew,
    'bar-chart-4-bars': BarChart4Bars,
    'bar-chart': BarChart,
    brochure: Brochure,
    'bullet-outline': BulletOutline,
    'bullet-solid': BulletSolid,
    calculate: Calculate,
    calculator: Calculator,
    'calendar-month': CalendarMonth,
    calendar: Calendar,
    'call-center': CallCenter,
    call: Call,
    'cancel-fill': CancelFill,
    careers: Careers,
    'check-box': CheckBox,
    'check-circle-outline': CheckCircleOutline,
    'check-circle': CheckCircle,
    check: Check,
    'chevron-down': ChevronDown,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    'chevron-up': ChevronUp,
    close: Close,
    'cloud-upload-fill': CloudUploadFill,
    'counter-1': Counter1,
    'counter-2': Counter2,
    'counter-3': Counter3,
    'counter-4': Counter4,
    'credit-card': CreditCard,
    'cross-circle': CrossCircle,
    'date-range': DateRange,
    delete: Delete,
    description: Description,
    disclaimer: Disclaimer,
    'diversity-1': Diversity1,
    'diversity-3': Diversity3,
    docs: Docs,
    dollar: Dollar,
    'download-box': DownloadBox,
    download: Download,
    eco: Eco,
    'edit-fill': EditFill,
    email: Email,
    emergency: Emergency,
    'error-outline': ErrorOutline,
    error: Error,
    'event-repeat': EventRepeat,
    'event-upcoming': EventUpcoming,
    exclamation: Exclamation,
    'external-link': ExternalLink,
    facebook: Facebook,
    faq: Faq,
    fax: Fax,
    'file-copy': FileCopy,
    'finance-mode': FinanceMode,
    forum: Forum,
    google: Google,
    groups: Groups,
    'headset-mic': HeadsetMic,
    help: Help,
    home: Home,
    'image-fill': ImageFill,
    info: Info,
    information: Information,
    instagram: Instagram,
    'keyboard-arrow-down': KeyboardArrowDown,
    language: Language,
    'lg-chevron-left': LgChevronLeft,
    'lg-chevron-right': LgChevronRight,
    link: Link,
    linkedin: Linkedin,
    'list-alt-check': ListAltCheck,
    list: List,
    'location-on': LocationOn,
    'lock-filled': LockFilled,
    login: Login,
    mail: Mail,
    'maps-fill': MapsFill,
    menu: Menu,
    messenger: Messenger,
    'money-bag': MoneyBag,
    monitoring: Monitoring,
    'more-horiz': MoreHoriz,
    'more-vert': MoreVert,
    moving: Moving,
    'nest-clock-farsight-analog': NestClockFarsightAnalog,
    'news-2': News2,
    news: News,
    office: Office,
    'open-in-new': OpenInNew,
    'page-info': PageInfo,
    paid: Paid,
    pdf: Pdf,
    'person-add': PersonAdd,
    'person-outline': PersonOutline,
    person: Person,
    'picture-as-pdf': PictureAsPdf,
    pinterest: Pinterest,
    'play-arrow': PlayArrow,
    'play-circle': PlayCircle,
    protection: Protection,
    'quick-reference': QuickReference,
    remove: Remove,
    'restart-alt': RestartAlt,
    savings: Savings,
    school: School,
    search: Search,
    secure: Secure,
    security: Security,
    seminars: Seminars,
    settings: Settings,
    share: Share,
    'shield-person': ShieldPerson,
    'source-environment': SourceEnvironment,
    'square-check': SquareCheck,
    star: Star,
    'supervised-user-circle': SupervisedUserCircle,
    'switch-account': SwitchAccount,
    task: Task,
    'text-snippet': TextSnippet,
    time: Time,
    translate: Translate,
    'upload-box': UploadBox,
    'verified-user': VerifiedUser,
    'visibility-off': VisibilityOff,
    visibility: Visibility,
    visit: Visit,
    warning: Warning,
    whatsapp: Whatsapp,
    x: X,
    youtube: Youtube,
};

interface IconProps {
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    icon: IconString | string;
    className?: string;
    // eslint-disable-next-line no-unused-vars
    onClick?: (event: ClickOrPressEvent) => void;
}

const Icon: React.FC<IconProps> = props => {
    const { icon, className, onClick } = props;
    const iconName = kebabCase(icon) as IconString;
    const SpecificIcon = allIconComponents[iconName];

    if (!SpecificIcon) {
        return null;
    }

    const isClickableClass = onClick ? 'svg-icon-clickable' : '';

    const iconClass = `svg-icon ${isClickableClass} ${className ? className : ''}`;

    return <SpecificIcon onClick={onClick} className={iconClass} />;
};

export default Icon;
